import { render, staticRenderFns } from "./addRecommendTag.vue?vue&type=template&id=e6a3e680"
import script from "./addRecommendTag.vue?vue&type=script&lang=js"
export * from "./addRecommendTag.vue?vue&type=script&lang=js"
import style0 from "./addRecommendTag.vue?vue&type=style&index=0&id=e6a3e680&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports